export const NumberUnitsField = {
  parts: [
    'OuterContainer',
    'Control',
    'Label',
    'InputContainer',
    'Input',
    'Preview',
    'Input',
    'Unit',
    'UnitSelect',
    'HelperText',
  ],
  baseStyle: {
    OuterContainer: {
      display: 'inline-block',
      verticalAlign: 'top',
    },
    Control: {
      margin: '0',
    },
    Label: {
      marginBottom: '20px',
      color: 'brand.black',
      fontWeight: 700,
    },
    InputContainer: {
      border: 'solid 1px',
      borderColor: 'brand.midgrey2',
      borderRadius: '4px',
      alignItems: 'center',
      ':focus-within': {
        borderColor: 'blue.500', // the default Chakra UI focus ring colour
        boxShadow: 'var(--chakra-shadows-outline)',
      },
    },
    Input: {
      flexGrow: 1,
      margin: '2px',
      errorBorderColor: 'brand.red',
      _placeholder: {
        color: 'brand.grey',
      },
    },
    Unit: {
      fontWeight: 'bold',
      padding: '0px 1em 0px 0.5em',
      whiteSpace: 'nowrap',
    },
    UnitSelect: {
      minWidth: '100px',
      paddingLeft: '15px',
      fontWeight: 'bold',
      ':focus': {
        borderColor: 'blue.500', // the default Chakra UI focus ring colour
        boxShadow: 'var(--chakra-shadows-outline)',
      },
    },
    HelperText: {},
  },
  variants: {
    '50%Width': {
      OuterContainer: {
        width: '50%',
        paddingRight: '22px',
        marginTop: '40px',
        verticalAlign: 'top',
      },
      Label: {
        fontSize: '12px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
      },
      Input: {
        padding: '16px 15px',
      },
    },
    '50%WidthShort': {
      OuterContainer: {
        width: '50%',
        paddingRight: '22px',
        marginTop: '32px',
        verticalAlign: 'top',
      },
      Label: {
        fontSize: '12px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
      },
      Input: {
        padding: '16px 15px',
      },
    },
    '100to50%WidthShort': {
      OuterContainer: {
        width: ['100%', '50%'],
        paddingRight: '22px',
        marginTop: '32px',
        verticalAlign: 'top',
      },
      Label: {
        fontSize: '12px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
      },
      Input: {
        padding: '16px 15px',
      },
    },
    fullWidth: {
      OuterContainer: {
        width: '100%',
        paddingRight: '22px',
      },
      Input: {
        padding: '16px 15px',
      },
    },
    percentValue: {
      OuterContainer: {
        marginTop: '20px',
        verticalAlign: 'top',
      },
      InputContainer: {
        maxWidth: '120px',
      },
      Label: {
        fontSize: '18px',
      },
      Input: {
        padding: '16px 0px 16px 14px',
      },
    },
    '25%WidthShort': {
      OuterContainer: {
        width: '25%',
        paddingRight: '22px',
        marginTop: '32px',
        verticalAlign: 'top',
      },
      Label: {
        fontSize: '12px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
      },
      Input: {
        padding: '16px 15px',
      },
    },
  },
  defaultProps: {
    variant: '50%Width',
  },
};
